import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';

import { routes } from './app/app-routing';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

import { paramAdderInterceptor } from './app/stocks/param-adder.interceptor';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
if (environment.production) {
  enableProdMode();
  window.console.log = function () {};
}

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{violet.50}',
      100: '{violet.100}',
      200: '{violet.200}',
      300: '{violet.300}',
      400: '{violet.700}',
      500: '{violet.700}',
      600: '{violet.700}',
      700: '{violet.700}',
      800: '{violet.700}',
      900: '{violet.900}',
      950: '{violet.950}',
    },
  },
});

document
  .querySelector('meta[name="theme-color"]')
  .setAttribute(
    'content',
    getComputedStyle(document.documentElement).getPropertyValue(
      '--p-primary-color'
    )
  );

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    importProvidersFrom(BrowserModule),
    provideHttpClient(withInterceptors([paramAdderInterceptor])),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false, // or 'none'
        },
      },
    }),
  ],
}).catch((err) => console.error(err));
